import { Breadcrumbs, PageBody, PageHeader, PageTitle } from 'modules';
import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

const ContractRejected = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader>
        <Breadcrumbs>
          <Breadcrumbs.Item to="/" active={false}>
            <Trans>ONLINE_FORMS.FORM</Trans>
          </Breadcrumbs.Item>
        </Breadcrumbs>
      </PageHeader>

      <Container className="m-0">
        <PageTitle title={t('ONLINE_FORMS.DETAIL')} />
        <PageBody>
          <Alert variant="danger">Riešenie Vášho prípadu ste odmietol</Alert>
        </PageBody>
      </Container>
    </>
  );
};

export default ContractRejected;
